import { TextFieldProps } from "@/types/components/textField"
import { HTMLProps, useState } from "react"

import classnames from "classnames"
import TextField from "@/components/form/textField/TextField"
import { IconButton } from "@mui/material"
import { RiEyeOffFill, RiEyeFill } from "@remixicon/react"

import "./passwordField.scss"

export default function PasswordField({ ...props }: TextFieldProps & HTMLProps<HTMLDivElement>) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <TextField
      {...props}
      className={classnames("PasswordFieldCont", props.className, { textHidden: !showPassword })}
      type={showPassword ? "text" : "password"}
      appendIcon={
        <IconButton disableRipple>
          {showPassword ? (
            <RiEyeOffFill onClick={() => setShowPassword(false)} />
          ) : (
            <RiEyeFill onClick={() => setShowPassword(true)} />
          )}
        </IconButton>
      }
    />
  )
}
